<div class="modal-content">
    <div class="modal-header bg-blue4">
        <h4 class="modal-title white text-bold-600" id="myModalLabel22">{{title}}</h4>
    </div>
    <div class="modal-body">
        <h5 class="text-bold-500">{{message1}}</h5>
        <p class="media-body">
        {{message2}}
        </p>
        <hr>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary btn-min-width mr-1 mb-1"
        (click)="activeModal.close('cancel')"><i class="feather ft-x"></i>Cancelar</button>
        <button type="button" class="btn btn-navy btn-min-width mr-1 mb-1" (click)="activeModal.close('accept')">
        <i class="feather ft-trash-2"></i>Confirmar</button>
    </div>
</div>